import { Policy } from '@amfam/policy/models';
import { Agent } from '@amfam/shared/utility/agent';

export class NotificationRequestInternalEmail {
  public producer: Agent;
  public policyList: Policy[];
  public firstName: string;
  public lastName: string;
  public email: string;
  public subject?: string;
  public content?: string;

  constructor(notificationRequest: NotificationRequest) {
    this.producer = notificationRequest.producer;
    this.policyList = notificationRequest.policyList;
    this.firstName = notificationRequest.firstName;
    this.lastName = notificationRequest.lastName;
    this.email = notificationRequest.email;
    this.subject = notificationRequest.subject;
    this.content = notificationRequest.content;
  }
}

export class NotificationRequest {
  public producer: Agent;
  public policyList: Policy[];
  public firstName: string;
  public lastName: string;
  public email: string;
  public subject?: string;
  public content?: string;
}
